import React from "react";

import { AiFillEye, AiFillGithub } from "react-icons/ai";

import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import { images } from "../../constants";

import "./Work.css";
import { useState } from "react";

const portfolioData = [
  {
    title: "Fashion Forward store",
    description:
      "This is a live clothing store that sells modern fashion to women, men and kids.",
    projectLink: "https://fashionfowardclothing.myshopify.com/",
    shopifyStore: true,
    imgUrl: images.fashionForwardStore,
    tags: ["Fashion"],
  },
  
  {
    title: "Fashion Forward store Design",
    description:
      "This is a Figma design of the Fashion Forward Store.",
    projectLink: "https://www.figma.com/file/KAoFOOhCsXL5MS2viQiP94/Clothing-Fashion-Store?type=design&mode=design&t=8lnF6e2yeOlwpo2L-1",
    shopifyStore: false,
    imgUrl: images.fashionForwardStore,
    tags: ["Figma"],
  },
  {
    title: "Palmpress Store",
    description:
      "This is a live single product store that sells palmpress coffee maker.",
    projectLink: "https://palmpresstore.myshopify.com/",
    shopifyStore: true,
    imgUrl: images.palmpressImg,
    tags: ["Appliances"],
  },
  {
    title: "Palmpress Store Design",
    description:
      "This is a Figma design of the Palmpress store.",
    projectLink: "https://www.figma.com/file/iF7yoKTNPqZN3VayMa48LK/Palmpress-Coffee?type=design&node-id=0%3A1&mode=design&t=AhmLhBLLPxhEPCj6-1",
    shopifyStore: false,
    imgUrl: images.palmpressImg,
    tags: ["Figma"],
  },
  {
    title: "Fybelle Store",
    description:
      "This is a hair removal single product store",
    projectLink: "https://fybellehandset.myshopify.com/",
    shopifyStore: true,
    imgUrl: images.fybelleStore,
    tags: ["Single Product"],
  },
  {
    title: "Fybelle Store Design",
    description:
      "This is a Figma Design of the Single Product Fybelle Store",
    projectLink: "https://www.figma.com/file/K12r1ZV6XtRtRH57W6jL5B/Fybelle?type=design&node-id=4%3A82&mode=design&t=db9p2UxAbbJrttZp-1",
    shopifyStore: false,
    imgUrl: images.fybelleStore,
    tags: ["Figma"],
  },
  
];

const Work = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  const [works, setWorks] = useState([]);

  const [filterWork, setFilterWork] = useState(portfolioData);
  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(portfolioData);
      } else {
        setFilterWork(portfolioData.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <>
      <h2 className="head-text">
        My Creative <span> Portfolio</span> Section
      </h2>

      <div className="app__work-filter">
        {["All", "Single Product", "Fashion", "Appliances", "Figma"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChilder: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.title} />

              <motion.div
                // whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-proj app__flex"
              >
                <a href={work.projectLink} target="_blank">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app_eye app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>

                
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              {
                work?.shopifyStore && (
                  <h4 className="bold-text">PASSWORD: <span className="small-font-text">dejanrobi</span></h4>
                )
              }
              
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
